import React from 'react'
import { Ellipses } from '../Pagination.styled'
import { PaginationItem } from './PaginationItem'

interface WrapperProps {
    ellipsesPosition: 'before' | 'after' | 'none'
    path: string
    isDisabled: boolean
    onPageChange: (x: number) => void
    currentPage: number
    nextPage: number
}
export const WrapperPages = ({
    ellipsesPosition,
    path,
    isDisabled,
    onPageChange,
    currentPage,
    nextPage,
}: WrapperProps) => {
    return (
        <>
            {ellipsesPosition === 'before' && <Ellipses>...</Ellipses>}
            <PaginationItem
                isDisabled={isDisabled}
                layout={{
                    showText: true,
                    display: {
                        default: {
                            display: 'none',
                        },
                        sm: {
                            display: 'flex',
                        },
                    },
                }}
                onClick={onPageChange}
                routePath={path}
                page={{ currentPage, nextPage }}
            />
            {ellipsesPosition === 'after' && <Ellipses>...</Ellipses>}
        </>
    )
}
